export const EmbedSettingNames = {
  embedAnkerName: 'uc-embed',
  embedTCFAnkerName: 'uc-embed-tcf',
  embedTitle: 'uc-embedding-title',
  embedType: 'uc-embedding-type',
  iabPurposeTitle: 'uc-embedding-purpose',
  iabVendorsTitle: 'uc-embedding-vendors',
  nonIabPurposeTitle: 'uc-embedding-non-iab-purpose',
  nonIabVendorsTitle: 'uc-embedding-non-iab-vendors',
  useUcStylining: 'uc-styling',
};

const Color = {
  blue: '#0000ff',
  darkGray: '#848484',
  lightGray: '#e2e2e2',
  white: '#fff',
};

export const Styles = {
  collapsableButton: {
    style:
      'border: none; display: inline-flex; background-color: white; text-align: left; padding: 15px; justify-content: space-between; width:100%',
  },
  collapsableDiv: {
    style: `border-bottom: 1px solid ${Color.lightGray}`,
  },
  collapsableDivContentHidden: {
    style: 'display: none',
  },
  collapsableDivContentShown: {
    style: 'display: inline-block; padding-bottom: 15px; width: 100%',
  },
  collapsableLink: {
    style:
      'border: none; display: inline-flex; background-color: white; text-align: left; padding: 7px 15px; margin: 0px; width:100%; justify-content: flex-start',
  },
  collapsedArrow: {
    style: `border: solid ${Color.darkGray}; border-width: 0 1px 1px 0; display: inline-block; padding: 3px; height: 0px; margin-top: 4px; margin-left:30px; transform: rotate(45deg); -webkit-transform: rotate(45deg);`,
  },
  collapsedButtonContent: {
    style: 'display: inline-block; font-weight: normal; font-size: 1.17em; margin: 0;',
  },
  collapsedLinkArrow: {
    style: `border: solid ${Color.blue}; border-width: 0 1px 1px 0; display: inline-block; padding: 3px; height: 0px; margin-top: 4px; margin-left:10px; transform: rotate(45deg); -webkit-transform: rotate(45deg);`,
  },
  collapsedLinkContent: {
    style: `display: inline-block; font-weight: bold; font-size: 1.0em; color: ${Color.blue}; margin-top: 1px`,
  },
  headlines: {
    style: 'padding: 7px 15px; margin: 0px',
  },
  headlinesBorderBottom: {
    style: `padding: 30px 15px 20px; margin: 0px; border-bottom: 1px solid ${Color.lightGray}`,
  },
  link: {
    style: 'font-size: 12px; padding: 0px 15px; text-decoration: none',
  },
  list: {
    style: 'display: inline-grid',
  },
  openedArrow: {
    style: `border: solid ${Color.darkGray}; border-width: 0 1px 1px 0; display: inline-block; padding: 3px; height: 0px; margin-top: 7px; margin-left:30px; transform: rotate(-135deg); -webkit-transform: rotate(-135deg);`,
  },
  openedButtonContent: {
    style: 'display: inline-block; font-weight: bold; font-size: 1.17em; margin: 0;',
  },
  openedLinkArrow: {
    style: `border: solid ${Color.blue}; border-width: 0 1px 1px 0; display: inline-block; padding: 3px; height: 0px; margin-top: 7px; margin-left:10px; transform: rotate(-135deg); -webkit-transform: rotate(-135deg);`,
  },
  outerBox: {
    style: 'display: grid; padding: 20px 0px; background-color: white; border-radius: 10px; font-family: "Arial"',
  },
  storedInfoAction: {
    style: 'display: flex; flex-direction: row; justify-content: center; width: 100%;',
  },
  storedInfoActionLink: {
    style: `font-size: 14px; margin: 0; cursor: pointer; color: ${Color.blue}`,
  },
  storedInfoActionText: {
    style: 'font-size: 14px; margin: 0',
  },
  storedInfoItem: {
    style: `display: flex; flex-direction: column; padding: 12px; border: 1px solid ${Color.lightGray};`,
  },
  storedInfoItemElement: {
    style: 'display: flex; flex-direction: row; width: 100%; font-size: 12px',
  },
  storedInfoItemHeader: {
    style: 'font-size: 12px; font-weight: bold; margin: 0px 0px 12px',
  },
  storedInfoItemSubElement: {
    style: 'flex: 0.33; margin: 0',
  },
  subElement: {
    style: 'margin: 5px 0px 15px',
  },
  subElementBlockList: {
    style: 'margin: 0px 0px 0px; padding: 0px 15px',
  },
  subElementBlockListElement: {
    style: `font-size: 12px; list-style: none; border: 1px solid ${Color.lightGray}; border-radius: 5px; padding: 10px; margin-top: 5px`,
  },
  subElementDescription: {
    style: 'font-size: 12px; padding: 0px 15px; margin: 5px 0px 0px',
  },
  subElementExpandableLink: {
    style: 'margin: 5px 15px 15px; width: calc(100% - 30px)',
  },
  subElementItemList: {
    style: 'margin: 5px 0px 10px; padding-right: 15px',
  },
  subElementItemListElement: {
    style: 'font-size: 12px; padding: 7px 0px 5px 0px',
  },
  viewMoreButton: {
    style: `border: none; background-color: ${Color.white}; text-align: left; padding: 15px; color: ${Color.blue}`,
  },
  /// End Region --- Collapsable Item Content Information Styles
};

export const Classnames = {
  collapseContent: 'uc-embed-collapse-content',
  collapsedArrow: 'uc-embed-collapsed-arrow',
  collapsedButton: 'uc-embed-collapsed-button',
  collapsedButtonContent: 'uc-embed-collapsed-button-content',
  collapsedLink: 'uc-embed-collapsed-link',
  collapsedLinkContent: 'uc-embed-collapsed-link-content',
  headline: 'uc-embed-headline',
  link: 'uc-embed-link',
  listDiv: 'uc-embed-list',
  listHeadline: 'uc-embed-list-headline',
  listItem: 'uc-embed-list-item',
  listItemContent: 'uc-embed-list-item-content',
  listItemHeadline: 'uc-embed-list-item-headline',
  openedArrow: 'uc-embed-opened-arrow',
  openedButton: 'uc-embed-opened-button',
  openedButtonContent: 'uc-embed-opened-button-content',
  openedLink: 'uc-embed-opened-link',
  openedLinkContent: 'uc-embed-opened-link-content',
  outerDiv: 'uc-embed-container',
  storedInfoAction: 'uc-embed-stored-info-action',
  storedInfoActionItem: 'uc-embed-stored-info-action-item',
  storedInfoItem: 'uc-embed-stored-info-item',
  storedInfoItemData: 'uc-embed-stored-info-item-data',
  storedInfoItemDataElement: 'uc-embed-stored-info-item-data-element',
  storedInfoItemHeadline: 'uc-embed-stored-info-item-headline',
  subElement: 'uc-embed-subelement',
  subElementBlockList: 'uc-embed-subelement-block-list',
  subElementBlockListElement: 'uc-embed-subelement-block-list-element',
  subElementDescription: 'uc-embed-subelement-description',
  subElementHeadline: 'uc-embed-subelement-headline',
  subElementItemList: 'uc-embed-subelement-item-list',
  subElementItemListElement: 'uc-embed-subelement-item-list-element',
  subElementStoredInfo: 'uc-embed-subelement-stored-info',
  viewMoreButton: 'uc-embed-block-list-view-more-button',
};
